import {
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Box,
  Typography,
  Button,
  Grid,
  Pagination,
  Skeleton,
} from "@mui/material"
import { Article } from "@mui/icons-material"
import { useState } from "react"

export const BlogsSection = ({ blogs, loading }) => {
  const [blogPage, setBlogPage] = useState(1)

  if (loading) {
    return (
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <Skeleton variant="text" width={120} height={32} />
            <Skeleton variant="rectangular" width={140} height={36} />
          </Box>
          <Grid container spacing={3}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} sm={6} md={3} key={item}>
                <Card>
                  <Skeleton variant="rectangular" height={160} />
                  <CardContent>
                    <Skeleton variant="text" width="90%" height={24} />
                    <Skeleton variant="text" width="80%" height={20} />
                    <Skeleton variant="text" width="60%" height={16} sx={{ mt: 2 }} />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h5" fontWeight="bold">
            Latest Blogs
          </Typography>
          <a href="https://www.groovenexus.com/press-releases/" target="_blank" className="gn-actionbtn-color ">
            View All Blogs
            <Article />
          </a>
        </Box>

        {blogs.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              No blogs available
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Check back later for new content
            </Typography>
          </Box>
        ) : (
          <>
            <Grid container spacing={3}>
              {blogs.map((blog, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card
                    sx={{
                      height: "100%",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: 4,
                        "& .blog-image": { transform: "scale(1.05)" },
                      },
                    }}
                  >
                    <Box sx={{ overflow: "hidden" }}>
                      <CardMedia
                        component="img"
                        height="160"
                        image={blog.image}
                        alt={blog.title}
                        className="blog-image"
                        sx={{ transition: "transform 0.3s ease" }}
                      />
                    </Box>
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {blog.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        gutterBottom
                        sx={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {blog.description}
                      </Typography>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
                        <Typography variant="caption" color="text.secondary">
                          {blog.author} • {blog.date}
                        </Typography>
                        <Typography variant="caption" color="primary">
                          {blog.readTime}
                        </Typography>
                      </Box>
                    </CardContent>
                    <CardActions>
                      <a href={blog.link} target="_blank" className=" gn-actionbtn-color ">
                        Read More
                      </a>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
            {/* <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <Pagination count={3} page={blogPage} onChange={(e, value) => setBlogPage(value)} color="primary" />
            </Box> */}
          </>
        )}
      </CardContent>
    </Card>
  )
}
